import { render, staticRenderFns } from "./WorkspaceNetworks.vue?vue&type=template&id=466306f7&"
import script from "./WorkspaceNetworks.vue?vue&type=script&lang=js&"
export * from "./WorkspaceNetworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports